module.exports = "/assets/data/9885272b20d8d127f9cd666943005080-NN17.data.json";